import { z } from "zod";
//#region src/api/orpc/shared/creditExchangeSchema.ts
const redeemTokenBaseSchema = z.object({
	partnerId: z.string(),
	partnerTransactionId: z.string(),
	partnerDeductedAmount: z.number().int(),
	quotaCurrency: z.string(),
	quotaAmount: z.number().int(),
	status: z.string(),
	expiresAt: z.string()
});
//#endregion
export { redeemTokenBaseSchema };
